import { z } from 'zod';
import { WHATSAPP_UNMATCHED_REASONS, WhatsAppFailureReasonSchema } from '../communications/whatsapp.schemas';

export const WHATSAPP_OPERATOR_LIST_MAX_LIMIT = 200;

export const ListWhatsAppFailedDispatchesPathParamsSchema = z.object({ workspaceId: z.uuid() });

export const WhatsAppOperatorListQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(WHATSAPP_OPERATOR_LIST_MAX_LIMIT).default(WHATSAPP_OPERATOR_LIST_MAX_LIMIT),
});

export const WhatsAppFailedDispatchSchema = z.object({
  id: z.uuid(),
  recipientPhone: z.string(),
  failureReason: WhatsAppFailureReasonSchema,
  providerErrorCode: z.number().int().nullable(),
  providerErrorDetail: z.string().nullable(),
  sentByMemberId: z.uuid(),
  sentByMemberName: z.string(),
  occurredAt: z.iso.datetime(),
});
export type WhatsAppFailedDispatch = z.infer<typeof WhatsAppFailedDispatchSchema>;

export const WhatsAppUnmatchedMessageSchema = z.object({
  id: z.uuid(),
  senderPhone: z.string(),
  profileName: z.string().nullable(),
  body: z.string(),
  reason: z.enum(WHATSAPP_UNMATCHED_REASONS),
  receivedAt: z.iso.datetime(),
});
export type WhatsAppUnmatchedMessage = z.infer<typeof WhatsAppUnmatchedMessageSchema>;

/** `truncated` rather than a cursor: the cap is the read's shape, and it must say when it bit. */
export const ListWhatsAppFailedDispatchesResponseSchema = z.object({
  data: z.array(WhatsAppFailedDispatchSchema),
  truncated: z.boolean(),
});
export type ListWhatsAppFailedDispatchesResponse = z.infer<typeof ListWhatsAppFailedDispatchesResponseSchema>;

export const ListWhatsAppUnmatchedMessagesResponseSchema = z.object({
  data: z.array(WhatsAppUnmatchedMessageSchema),
  truncated: z.boolean(),
});
export type ListWhatsAppUnmatchedMessagesResponse = z.infer<typeof ListWhatsAppUnmatchedMessagesResponseSchema>;
